export default __webpack_public_path__ + "static/media/mpower2.93239a61.png";